export default async function getAboutUs({ context, nextMiddleware }){
    try {
        context.store.dispatch('menuUI/selectTab', 'aboutUs');
    }
    catch(e){
        console.error(e);
        return context.next(false);
    }
    return nextMiddleware()
}
